import React from "react";
import { Tooltip as BsTooltip, OverlayTrigger } from "react-bootstrap";

export const Tooltip = ({ title, children }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={(
        <BsTooltip>
          <div className="p-2">{title}</div>
        </BsTooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
};
